/** 订单详情
 * 有user_id则直接使用user_id, 没有则需要登录
 * **/

import './index.less';
import React, {useEffect, useState} from 'react';
import {convertPrice} from '@utils/tools';
import {mapDealStateText, convertGender, VIDEO_SUPPORT_MAP} from '@utils/public';
import {storage, goPay} from '@utils/tools';
import ListItem from '@comp/ListItem';
import BackHeader from '@comp/BackHeader';
import queryString from 'query-string';
import {fetchDeal, fetchSmsWxPay} from '@/store/api/deal';
import {Button, List, Toast} from 'antd-mobile';
import dayjs from 'dayjs';

const COUPON_INFO = 'COUPON_INFO'; //挂号券信息

function DealDetailCoupon(props) {
  const [dealData, setDealData] = useState({});
  const {user_id, deal_id} = queryString.parse(props.location.search);
  const [coupon, setCoupon] = useState(storage.get(COUPON_INFO + '_1') || {});

  useEffect(() => {
    document.title = '固生堂 - 订单详情';
    let coupon = storage.get(COUPON_INFO + '_1');
    console.log('获取选择的优惠券', coupon);
    if (coupon) setCoupon(coupon);
  }, []);

  useEffect(() => {
    updateDeal();
  }, [deal_id, user_id]);

  const updateDeal = () => {
    fetchDeal({deal_id, user_id}).then(json => {
      if (json.isOK) {
        setDealData(json);
      } else {
        Toast.show({
          icon: 'fail',
          content: `[${json.status}] ${json.message || json.detail}`,
        });
      }
    });
  };

  const onPay = () => {
    const {deal_id, user_id, integral, deal_create_time, deal_type, price, recipe_total_money} = dealData;
    const {cp_id, cp_value} = coupon;

    let postData = {
      user_id: user_id,
      deal_id: deal_id,
      scene: '11',
      integral: integral,
      timestamp: deal_create_time,
      price: deal_type === '2' ? price : recipe_total_money, //商城单/预约单 价格字段不同
      type: deal_type,
      coupon_record_id: cp_id || '',
    };

    postData.ticket = '';

    if (/^development|dev|test$/.test(process.env.REACT_APP_ENV)) {
      postData.dev = 1;
    } else if (process.env.REACT_APP_ENV === 'stg') {
      postData.dev = 2;
    } else {
      postData.dev = 0;
    }

    fetchSmsWxPay(postData).then(res => {
      console.log('支付接口pay/request返回', res);
      clearCoupon();
      if (+res.status === 8465) {
        location.reload();
      } else {
        goPay(`${props.location.search}&coupon_id=${cp_id || ''}&coupon_value=${cp_value || 0}`);
      }
    });
  };

  const clearCoupon = () => {
    storage.remove(COUPON_INFO + '_1');
  };

  const deal_state_text = mapDealStateText(dealData.deal_state, dealData.video);
  const clinicAddress =
    dealData.video === '3'
      ? [
          {label: '就诊医院', text: dealData.clinic_name},
          {label: '就诊地址', text: dealData.clinic_address},
        ]
      : [];
  const clinicInfo = [
    {label: '就诊医生', text: dealData.doctor_name},
    {label: '就诊科室', text: dealData.department_name},
    ...clinicAddress,
    {label: '就诊时间', text: dayjs.unix(dealData.reservation_start_time).format('YYYY-MM-DD HH:mm')},
    {label: '就诊方式', text: VIDEO_SUPPORT_MAP[dealData.video]},
  ];
  const patientInfo = [
    {label: '就诊人', text: dealData.patient_name},
    {label: '性别', text: convertGender(dealData.patient_sex)},
    {label: '生日', text: dealData.patient_birth},
    {label: '预约手机', text: dealData.patient_phone},
  ];
  const priceInfo = [
    {label: '订单金额', text: `¥ ${convertPrice(dealData.receivable_price)}`, txtType: 'after'},
    {
      label: '实付款',
      text: `¥ ${convertPrice(dealData.price - (coupon.cp_value || 0) * 10000)}`,
      txtType: 'after',
      txtClass: 'color-danger',
    },
  ];
  const couponInfo = [
    {
      label: '优惠券',
      text: coupon.cp_value ? `- ¥ ${coupon.cp_value || 0}` : '请选择',
      txtType: 'after',
      url: `/coupon/choose?deal_id=${dealData.deal_id}&user_id=${dealData.user_id}&doctor_id=${dealData.orgi_doctor_id}&shop_no=${dealData.clinic_id}&coupon_value_limit=${dealData.price}&coupon_way_limit=8&use_range=1`,
    },
  ];

  return (
    <article className="page deal-detail-coupon">
      <BackHeader title={'订单详情'} right={null} />
      <section className="main">
        <div className="content-block-inner">
          <span>订单号：{deal_id}</span>
          <span>{deal_state_text}</span>
        </div>
        <ListItem list={clinicInfo} />
        <ListItem list={patientInfo} />
        <ListItem list={couponInfo} />
        <ListItem list={priceInfo} className="price-list" />
        <List className="footer">
          <List.Item>
            <Button block color="danger" onClick={onPay}>
              去支付
            </Button>
          </List.Item>
        </List>
      </section>
    </article>
  );
}

export default DealDetailCoupon;
